// NOTE: Check color in Figma MISO Design System.
// https://www.figma.com/file/Ks43XNUyjnYd0Tc1SzRf8H/Miso-Design-Library-Components?node-id=0%3A1

export const BLUE_01 = '#055CF5';
export const BLUE_02 = '#eff7ff';
export const BLUE_03 = '#0A30A8';

export const BLACK = '#080808';
export const WHITE = '#FFFFFF';

export const GREY_MODAL = '#2E3035';
export const GREY_DARK = '#62656A';
export const GREY_MEDIUM = '#A3A7AE';
export const GREY_LIGHT = '#C7CAD0';
export const GREY_EXLIGHT = '#F3F4F8';

export const DARK_NAVY = '#00395B';
